import { withAccessToken, authFetch } from "./auth";
import buildEndpoint from "./utils/buildEndpoint";
import downloadFile from "./utils/download";
import fetchJSON from "./utils/fetchJSON";

const API_ENDPOINT = "/api";

const formatToQueryString = queryObj => {
  if (queryObj) {
    return Object.keys(queryObj)
      .map(key => {
        const value = queryObj[key];
        return value && `${key}=${value}`;
      })
      .filter(string => typeof string === "string")
      .join("&");
  }

  return "";
};

export function requestPasswordReset(email) {
  return fetchJSON(`${API_ENDPOINT}/password_resets`, {
    method: "POST",
    body: {
      email
    }
  });
}

export function getPasswordResetRequest(token) {
  return fetchJSON(`${API_ENDPOINT}/password_resets/${token}`);
}

export function resetPassword(token, password) {
  return fetchJSON(`${API_ENDPOINT}/password_resets/${token}`, {
    method: "PATCH",
    body: {
      user: {
        password
      }
    }
  });
}

export function getTransmittals(jobId) {
  return fetchJSON(`${API_ENDPOINT}/transmittals?job_id=${jobId}`, {
    customFetch: authFetch
  });
}

export function getTransmittal(id) {
  return fetchJSON(`${API_ENDPOINT}/transmittals/${id}`, {
    customFetch: authFetch
  });
}

export function saveTransmittal(id, data) {
  return fetchJSON(`${API_ENDPOINT}/transmittals${id ? "/" + id : ""}`, {
    customFetch: authFetch,
    method: id ? "PATCH" : "POST",
    body: {
      transmittal: data
    }
  });
}

export function getReport(id, query) {
  const queryString = formatToQueryString(query);
  return fetchJSON(`${API_ENDPOINT}/reports/${id}?${queryString}`, {
    customFetch: authFetch
  });
}

export function downloadReport(id, options = {}) {
  const { query = {}, filename = id } = options;
  const queryString = formatToQueryString(query);
  return withAccessToken(token => {
    downloadFile(
      buildEndpoint(
        `${API_ENDPOINT}/reports/${id}.csv?${queryString}&auth_token=${token}`
      ),
      `${filename}.csv`
    );
  });
}

export function getTransmittalTemplates() {
  return fetchJSON(`${API_ENDPOINT}/transmittal_templates`, {
    customFetch: authFetch
  }).then(response => response.transmittal_templates);
}

export function getTransmittalTemplate(id) {
  return fetchJSON(`${API_ENDPOINT}/transmittal_templates/${id}`, {
    customFetch: authFetch
  }).then(response => response.transmittal_template);
}

export function saveTransmittalTemplate(id, data) {
  return fetchJSON(
    `${API_ENDPOINT}/transmittal_templates${id ? "/" + id : ""}`,
    {
      customFetch: authFetch,
      method: id ? "PATCH" : "POST",
      body: data
    }
  );
}

export function getInvitation(token) {
  return fetchJSON(`${API_ENDPOINT}/invitations/${token}`, { method: "GET" });
}

export function acceptInvitation(token, data) {
  return fetchJSON(`${API_ENDPOINT}/invitations/${token}`, {
    method: "PATCH",
    body: data
  });
}

const defaultCreateAttachmentOptions = {
  onStart: () => undefined,
  onProgress: () => undefined,
  onSuccess: () => undefined,
  onError: () => undefined,
  headers: {}
};

export function uploadAttachment(
  attachment,
  options = defaultCreateAttachmentOptions
) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    // Build form request
    const formData = new FormData();
    formData.append("attachment[name]", attachment.name);
    formData.append("attachment[original_filename]", attachment.file.name);
    formData.append("attachment[file]", attachment.file);
    if (attachment.contentType) {
      formData.append("attachment[content_type]", attachment.contentType);
    }
    if (attachment.byteSize) {
      formData.append("attachment[byte_size]", attachment.byteSize);
    }
    formData.append("attachment[attachment_type]", attachment.attachmentType);
    formData.append("attachment[service_id]", attachment.serviceId);

    xhr.open("POST", buildEndpoint(`${API_ENDPOINT}/attachments`), true);

    // Set headers
    Object.keys(options.headers).forEach(key => {
      xhr.setRequestHeader(key, options.headers[key]);
    });
    xhr.setRequestHeader("Accept", "application/json");

    if (xhr.upload) {
      xhr.upload.onloadstart = options.onStart;
      xhr.upload.onprogress = options.onProgress;
    }

    xhr.onload = function() {
      if (this.status >= 200 && this.status < 300) {
        resolve(xhr.response);
      } else {
        reject({
          status: this.status,
          statusText: this.statusText
        });
      }
    };
    xhr.onerror = function() {
      reject({
        status: this.status,
        statusText: this.statusText
      });
    };
    xhr.send(formData);
  });
}



// WEBPACK FOOTER //
// ./src/api.js